(function(){
function init(root){
  var dataEl=root.querySelector('script[data-bp-data]');
  if(!dataEl||root.__bp) return; root.__bp=1;
  var D=JSON.parse(dataEl.textContent);
  var q=function(s){return root.querySelector(s)};
  var qa=function(s){return Array.prototype.slice.call(root.querySelectorAll(s))};
  function money(c){
    var v=(c/100).toFixed(2).replace('.',',');
    var f=D.money||'X €';
    return f.indexOf('{'+'{')>-1?f.replace(/\{\{\s*[a-z_]+\s*\}\}/,v):v+' €';
  }
  function byId(id){return D.variants.filter(function(v){return v.id==id})[0]}
  function byValue(val){return D.variants.filter(function(v){return v.o1===val})[0]}
  function darker(hex){
    if(!hex||hex.charAt(0)!=='#'||hex.length<7) return hex||'#282A30';
    var r=parseInt(hex.substr(1,2),16),g=parseInt(hex.substr(3,2),16),b=parseInt(hex.substr(5,2),16);
    var lum=(0.2126*r+0.7152*g+0.0722*b)/255;
    if(lum<0.18) return hex;
    var k=0.45; function h(x){x=Math.round(x*k).toString(16);return x.length<2?'0'+x:x}
    return '#'+h(r)+h(g)+h(b);
  }
  var state={v1:byId(D.current)||D.variants[0],v2:null,second:false,gift:false,engr:false};

  var track=q('[data-track]'), dotsWrap=q('[data-dots]'), dots=[];
  function visibleFigs(){return qa('[data-track] figure').filter(function(f){return !f.hidden})}
  function setActive(i){dots.forEach(function(b,j){b.setAttribute('aria-current',j===i?'true':'false')})}
  function buildDots(){
    if(!dotsWrap) return; dotsWrap.innerHTML=''; dots=[];
    var n=visibleFigs().length;
    dotsWrap.classList.toggle('x-many',n>12); dotsWrap.hidden=n<2;
    for(var i=0;i<n;i++){(function(i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Bild '+(i+1));b.addEventListener('click',function(){track.scrollTo({left:i*track.clientWidth,behavior:'smooth'})});dotsWrap.appendChild(b);dots.push(b);})(i)}
    setActive(0);
  }
  function filterGallery(color){
    if(!track) return;
    var figs=qa('[data-track] figure');
    var tagged=figs.some(function(f){var c=f.getAttribute('data-color');return c&&c!=='*'});
    var any=false;
    figs.forEach(function(f){var c=f.getAttribute('data-color');var show=!tagged||!c||c==='*'||c===color;f.hidden=!show;if(show)any=true});
    if(!any) figs.forEach(function(f){f.hidden=false});
    track.scrollLeft=0; buildDots();
  }
  if(track) track.addEventListener('scroll',function(){setActive(Math.round(track.scrollLeft/track.clientWidth))},{passive:true});

  function stockInfo(v){
    if(!v.available) return {c:'var(--b-warn)',ci:'var(--b-warn-ink)',t:'Ausverkauft',x:v.o1||''};
    if(v.managed && v.qty<=0) return {c:'var(--b-warn)',ci:'var(--b-warn-ink)',t:'Vorbestellen',x:(v.o1?v.o1+', ':'')+D.preText};
    return {c:'var(--b-ok)',ci:'var(--b-ok-ink)',t:'Auf Lager',x:(v.o1?v.o1+', ':'')+D.shipText};
  }
  function setStock(n,v){
    var el=q('[data-stock="'+n+'"]'); if(!el) return;
    if(!v){el.hidden=true;return}
    var s=stockInfo(v); el.hidden=false;
    el.querySelector('.x-dot').style.background=s.c;
    var b=el.querySelector('b'); b.textContent=s.t; b.style.color=s.ci;
    el.querySelector('span > span').textContent=s.x;
  }
  function paintLeather(n,v){
    var hex=v&&v.color?v.color:'#282A30';
    var l=q('[data-leather="'+n+'"]'); if(l){l.style.backgroundColor=darker(hex); l.classList.toggle('x-smooth',/schwarz|black/i.test(v&&v.o1||''));}
    if(n===1){var m=q('[data-mini]'); if(m) m.style.backgroundColor=darker(hex);}
  }
  function render(){
    var v1=state.v1, v2=state.second?state.v2:null;
    qa('[data-swatches="1"] .x-sw').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-value')===v1.o1?'true':'false')});
    qa('[data-swatches="2"] .x-sw').forEach(function(b){b.setAttribute('aria-pressed',v2&&b.getAttribute('data-value')===v2.o1?'true':'false')});
    var cn=q('[data-color-name]'); if(cn) cn.textContent=v1.o1;
    var c2=q('[data-color2-name]'); if(c2&&state.v2) c2.textContent=state.v2.o1;
    var bc=q('[data-bar-color]'); if(bc) bc.textContent=v2?v1.o1+' + '+v2.o1:v1.o1;
    var p=q('[data-price]'); if(p) p.innerHTML=money(v1.price)+(v1.compare>v1.price?'<s>'+money(v1.compare)+'</s>':'');
    var sp=q('[data-second-price]'); if(sp) sp.textContent='+ '+money(Math.round((state.v2||v1).price/2));
    var sb=q('[data-second]'); if(sb) sb.setAttribute('aria-pressed',state.second?'true':'false');
    var panel=q('[data-second-panel]'); if(panel) panel.hidden=!state.second;
    paintLeather(1,v1); if(state.v2) paintLeather(2,state.v2);
    var e2=q('[data-engr2]'); if(e2) e2.hidden=!v2;
    var f1=q('[data-engr-for1]'); if(f1) f1.hidden=!v2;
    var n1=q('[data-engr-name1]'); if(n1) n1.textContent=v1.o1;
    var n2=q('[data-engr-name2]'); if(n2&&v2) n2.textContent=v2.o1;
    setStock(1,v1); setStock(2,v2);
    var total=v1.price+(v2?Math.round(v2.price/2):0);
    var cta=q('[data-cta]'); cta.textContent=v1.available?'In den Warenkorb – '+money(total):'Ausverkauft'; cta.disabled=!v1.available;
    var bcta=q('[data-bar-cta]'); if(bcta) bcta.disabled=!v1.available;
    var bp=q('[data-bar-price]'); if(bp) bp.textContent=money(total);
  }
  qa('[data-swatches="1"] .x-sw').forEach(function(b){b.addEventListener('click',function(){
    var v=byValue(b.getAttribute('data-value')); if(!v) return; state.v1=v; render(); filterGallery(v.o1);
    if(window.history&&history.replaceState){try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u)}catch(e){}}
  })});
  qa('[data-swatches="2"] .x-sw').forEach(function(b){b.addEventListener('click',function(){var v=byValue(b.getAttribute('data-value')); if(v){state.v2=v; render();}})});
  var sb=q('[data-second]');
  if(sb) sb.addEventListener('click',function(){
    state.second=!state.second;
    if(state.second&&!state.v2){ state.v2=D.variants.filter(function(v){return v.available&&v.qty>0&&v.id!==state.v1.id})[0]||D.variants.filter(function(v){return v.available&&v.id!==state.v1.id})[0]||state.v1; }
    render();
  });
  var gb=q('[data-gift]');
  if(gb) gb.addEventListener('click',function(){
    state.gift=!state.gift; gb.setAttribute('aria-pressed',state.gift?'true':'false');
    q('[data-gift-sub]').textContent=state.gift?'✓ '+D.giftOn:D.giftOff;
  });
  var et=q('[data-engr-toggle]');
  if(et) et.addEventListener('click',function(){
    var body=q('[data-engr-body]'); body.hidden=!body.hidden; state.engr=!body.hidden;
    et.setAttribute('aria-expanded',state.engr?'true':'false');
  });
  var ib=q('[data-info]');
  if(ib) ib.addEventListener('click',function(){var p=q('[data-info-pop]'); p.hidden=!p.hidden; ib.setAttribute('aria-expanded',p.hidden?'false':'true');});
  qa('input.x-gin').forEach(function(inp){
    var n=inp.getAttribute('data-gin');
    inp.addEventListener('input',function(){
      var v=String(inp.value||'').toUpperCase().replace(/[^A-ZÄÖÜ. ]/g,'').replace(/ {2,}/g,' ').replace(/^ /,'').slice(0,D.engrLimit);
      if(inp.value!==v) inp.value=v;
      var ph=n==='2'?'LM':'TK';
      var em=q('[data-emboss="'+n+'"]'); em.textContent=v||ph; em.style.opacity=v?'1':'.5';
      if(n==='1'){var mt=q('[data-mini-text]'); if(mt){mt.textContent=v||'TK'; mt.style.opacity=v?'1':'.5';}}
    });
    inp.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); inp.blur(); } });
  });
  function outBlur(e){ var a=document.activeElement; if(a&&a.classList&&a.classList.contains('x-gin')&&e.target!==a){ a.blur(); } }
  document.addEventListener('touchstart',outBlur,{passive:true});
  document.addEventListener('mousedown',outBlur);

  function engrLine(v,text){
    var p={'Personalisierung für':D.title+'-'+(v.title==='Default Title'?'':v.title),'Personalisierung ID':''+v.id};
    p[D.engrLabel]=text;
    return {id:D.engr,quantity:1,properties:p};
  }
  function addToCart(btn){
    var err=q('[data-err]'); err.hidden=true;
    var v1=state.v1; if(!v1.available) return;
    var items=[{id:v1.id,quantity:1}];
    var t1=(q('[data-gin="1"]')||{}).value||'';
    var t2=(q('[data-gin="2"]')||{}).value||'';
    if(D.engr&&state.engr&&t1.trim()) items.push(engrLine(v1,t1.trim()));
    if(state.second&&state.v2&&state.v2.available){
      items.push({id:state.v2.id,quantity:1});
      if(D.engr&&state.engr&&t2.trim()) items.push(engrLine(state.v2,t2.trim()));
    }
    if(D.gift&&state.gift) items.push({id:D.gift,quantity:1});
    btn.classList.add('x-loading'); btn.disabled=true;
    fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        btn.classList.remove('x-loading'); btn.disabled=false;
        if(!res.ok){ err.textContent=res.j&&res.j.description?res.j.description:'Leider ist etwas schiefgelaufen. Bitte versuche es erneut.'; err.hidden=false; return; }
        document.documentElement.dispatchEvent(new CustomEvent('variant:added',{bubbles:true,detail:{variant:res.j.items?res.j.items[0]:res.j}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        setTimeout(function(){ var d=document.getElementById('mini-cart'); if(!d||!d.hasAttribute('open')){ if(d&&typeof d.show==='function'){d.show()} else if(d){d.setAttribute('open','')} else {location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart'} } },700);
      })
      .catch(function(){btn.classList.remove('x-loading'); btn.disabled=false; err.textContent='Leider ist etwas schiefgelaufen. Bitte versuche es erneut.'; err.hidden=false;});
  }
  q('[data-cta]').addEventListener('click',function(){addToCart(this)});
  var bcta=q('[data-bar-cta]'); if(bcta) bcta.addEventListener('click',function(){addToCart(this)});

  var bar=q('[data-bar]');
  function barCheck(){ var max=document.documentElement.scrollHeight-window.innerHeight; bar.classList.toggle('x-show',max>0&&window.scrollY>=max*0.5); }
  window.addEventListener('scroll',barCheck,{passive:true}); window.addEventListener('resize',barCheck); barCheck();
  render(); filterGallery(state.v1.o1);
}
function boot(){Array.prototype.forEach.call(document.querySelectorAll('[data-bp-root]'),init)}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}else{boot()}
document.addEventListener('shopify:section:load',boot);
})();
